import { render, staticRenderFns } from "./InstitutionsImportForm.vue?vue&type=template&id=9193f57e&"
import script from "./InstitutionsImportForm.vue?vue&type=script&lang=js&"
export * from "./InstitutionsImportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports